var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithinTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people-24",
    "data-name": "people"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 5.02,
    r: 3.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 9h-4a3.78 3.78 0 0 0 -4 3.5v5a2.71 2.71 0 0 0 2 2.5v6.82a2.1 2.1 0 0 0 2 2.18h4a2.1 2.1 0 0 0 2-2.18v-6.82a2.71 2.71 0 0 0 2-2.5v-5a3.78 3.78 0 0 0 -4-3.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.6 13h-3.2a3.19 3.19 0 0 0 -3.4 2.9v3.81a2.37 2.37 0 0 0 2 2.21v5.13a1.81 1.81 0 0 0 1.69 1.95h2.76a1.81 1.81 0 0 0 1.69-1.95v-5.17a2.34 2.34 0 0 0 1.86-2.17v-3.81a3.19 3.19 0 0 0 -3.4-2.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithinTeam);
export default __webpack_public_path__ + "static/media/WithinTeam.e6d2ecc4b5d0f9d86c7cd82fb557340b.svg";
export { ForwardRef as ReactComponent };